import styled from "@emotion/styled";

const Select = styled.select`
  width: 100%;
  height: 48px;
  padding: 0 14px;
  font-size: 15px;
  border: 1px solid #d9dde2;
  border-radius: 10px;
  background: #ffffff
    url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path d='M1 1l5 5 5-5' stroke='%23888' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>")
    no-repeat right 14px center;
  background-size: 12px 8px;
  appearance: none;
  -webkit-appearance: none;
  color: #222222;
  outline: none;

  &:focus {
    border-color: #003580;
  }
  &:disabled {
    background-color: #f6f7f9;
    color: #888888;
  }
`;

export default Select;
